import {useEffect, useMemo, useState} from 'react';
import s from './index.module.less';

const ProjectCatalog = ({projects, onOpen}) => {
    const [query, setQuery] = useState('');
    const [collection, setCollection] = useState('全部');
    const [category, setCategory] = useState('全部方向');
    const categories = useMemo(() => ['全部方向', ...new Set(projects.map(project => project.category))], [projects]);
    const visible = useMemo(() => projects.filter(project =>
        (collection === '全部' || project.collection === collection)
        && (category === '全部方向' || project.category === category)
        && `${project.title} ${project.desc} ${project.keywords} ${(project.aliases || []).join(' ')}`.toLowerCase().includes(query.trim().toLowerCase())
    ), [projects, collection, category, query]);

    useEffect(() => {
        const reveal = () => {
            const hash = window.location.hash.slice(1);
            const project = projects.find(item => hash === `project-${item.id}` || (Number.isInteger(item.legacyIndex) && hash === `resume-project-${item.legacyIndex}`));
            if (!project) return;
            setQuery('');
            setCollection('全部');
            setCategory('全部方向');
            onOpen({type: 'project', key: project.id, payload: project});
        };
        const repeatAnchor = event => {
            const anchor = event.target.closest('a[href^="#"]');
            if (anchor && anchor.getAttribute('href') === window.location.hash) reveal();
        };
        reveal();
        window.addEventListener('hashchange', reveal);
        document.addEventListener('click', repeatAnchor);
        return () => {
            window.removeEventListener('hashchange', reveal);
            document.removeEventListener('click', repeatAnchor);
        };
    }, [projects, onOpen]);

    const open = (event, project) => {
        event.currentTarget.focus({preventScroll: true});
        onOpen({type: 'project', key: project.id, payload: project});
    };

    return <section className={s.projectCatalog} id='project-catalog' aria-labelledby='project-catalog-title'>
        <header className={s.catalogHead}>
            <div><span>SELECTED DEPTH / COMPLETE SCOPE</span><h2 id='project-catalog-title'>项目与实践</h2><p>从技术判断到系统实现，再到业务使用与持续演进。</p></div>
            <a href='#capability-model'>回看能力全景 ↗</a>
        </header>
        <div className={s.catalogControls}>
            <div className={s.catalogCollections} aria-label='项目来源'>
                {['全部', '简历项目', 'AI LAB 项目', '早期项目'].map(name => <button type='button' key={name} aria-pressed={collection === name} onClick={() => setCollection(name)}>{name}</button>)}
            </div>
            <div className={s.catalogSearch}>
                <label><span>检索项目</span><input type='search' value={query} onChange={event => setQuery(event.target.value)} placeholder='名称、方向或关键词…'/></label>
                <label><span>方向</span><select value={category} onChange={event => setCategory(event.target.value)}>{categories.map(name => <option key={name}>{name}</option>)}</select></label>
            </div>
        </div>
        <p className={s.catalogStatus} role='status'>{visible.length} 项匹配<span>资料截止 2026.09.13 · 各项目按实际阶段展示</span></p>
        <div className={s.catalogGrid}>
            {visible.map(project => <article className={s.catalogCard} key={project.id} id={`project-${project.id}`} data-collection={project.collection}>
                {Number.isInteger(project.legacyIndex) ? <span className={s.catalogAnchor} id={`resume-project-${project.legacyIndex}`}/> : null}
                <div className={s.catalogCardMeta}><span>{project.category}</span><em>{project.stage}</em></div>
                <h3><button type='button' className={s.summaryCardTrigger} aria-haspopup='dialog' onClick={event => open(event, project)}>{project.title}</button></h3>
                <p className={s.catalogCardDescription}>{project.desc}</p>
                {project.metric ? <p className={s.catalogCardResult}>{project.metric}</p> : null}
                <footer><span>{project.collection}</span><span>{project.architectureKey ? '详情与架构' : '查看详情'} <i aria-hidden='true'>↗</i></span></footer>
            </article>)}
        </div>
        {!visible.length ? <div className={s.catalogEmpty}><p>没有匹配的项目</p><button type='button' onClick={() => {setQuery(''); setCategory('全部方向'); setCollection('全部');}}>清除筛选</button></div> : null}
    </section>;
};

export default ProjectCatalog;
